/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { GetConversationQueryResponse, GetConversationPathParams, GetConversation401, GetConversation500 } from "../../types/chatController/GetConversation.ts";
import type { Client, RequestConfig, ResponseErrorConfig } from "@packages/api-client/client-config";
import type { QueryKey, QueryClient, UseSuspenseQueryOptions, UseSuspenseQueryResult } from "@tanstack/react-query";
import { getConversation } from "../../client/chatController/getConversation.ts";
import { queryOptions, useSuspenseQuery } from "@tanstack/react-query";

export const getConversationSuspenseQueryKey = (organizationId: GetConversationPathParams["organizationId"] | undefined, conversationId: GetConversationPathParams["conversationId"] | undefined) => [{ url: '/api/organizations/:organizationId/chat/conversations/:conversationId', params: {organizationId:organizationId,conversationId:conversationId} }] as const

export type GetConversationSuspenseQueryKey = ReturnType<typeof getConversationSuspenseQueryKey>

export function getConversationSuspenseQueryOptions(organizationId: GetConversationPathParams["organizationId"], conversationId: GetConversationPathParams["conversationId"], config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = getConversationSuspenseQueryKey(organizationId, conversationId)
        return queryOptions<GetConversationQueryResponse, ResponseErrorConfig<GetConversation401 | GetConversation500>, GetConversationQueryResponse, typeof queryKey>({
         
         queryKey,
         queryFn: async ({ signal }) => {
            return getConversation(organizationId, conversationId, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @summary Get a single conversation with messages
 * {@link /api/organizations/:organizationId/chat/conversations/:conversationId}
 */
export function useGetConversationSuspense<TData = GetConversationQueryResponse, TQueryKey extends QueryKey = GetConversationSuspenseQueryKey>(organizationId: GetConversationPathParams["organizationId"], conversationId: GetConversationPathParams["conversationId"], options: 
{
  query?: Partial<UseSuspenseQueryOptions<GetConversationQueryResponse, ResponseErrorConfig<GetConversation401 | GetConversation500>, TData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...resolvedOptions } = queryConfig
         const queryKey = resolvedOptions?.queryKey ?? getConversationSuspenseQueryKey(organizationId, conversationId)
         

         const query = useSuspenseQuery({
          ...getConversationSuspenseQueryOptions(organizationId, conversationId, config),
          ...resolvedOptions,
          queryKey,
         } as unknown as UseSuspenseQueryOptions, queryClient) as UseSuspenseQueryResult<TData, ResponseErrorConfig<GetConversation401 | GetConversation500>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}